// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-index-productDay-lwabw{width:100%}.pages-index-productDayWrapper-knqfi.pages-index-mobile-dsjnp{margin-left:-12px;margin-right:-12px}.pages-index-productsBlock3-bwxlq{margin-bottom:24px}.pages-index-productsBlock3-bwxlq:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"productDay": "pages-index-productDay-lwabw",
	"productDayWrapper": "pages-index-productDayWrapper-knqfi",
	"mobile": "pages-index-mobile-dsjnp",
	"productsBlock3": "pages-index-productsBlock3-bwxlq"
};
module.exports = ___CSS_LOADER_EXPORT___;
